const BASE = process.env.NODE_API_URL;

// `image` pode ser: vazio/nulo, um storedName (uuid.ext) servido pela API em
// /api/avatar/:name, ou já uma URL completa (http/data) — nesse caso usa como está.
export const resolveAvatarUrl = (image?: string | null): string | undefined => {
  if (!image) return undefined;
  if (/^(https?:|data:)/i.test(image)) return image;
  return `${BASE}/api/avatar/${image}`;
};
